import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GridsterItem } from 'angular-gridster2';
import { ReplaySubject, Subject } from 'rxjs';
import { PdfExportDefaultTemplateModalComponent } from '../components/pdf-export-default-template-modal/pdf-export-default-template-modal.component';
import { DynamicPdfService } from './dynamic-pdf.service';
import { first } from 'rxjs/operators';
import { PdfDocument } from '../models/pdf-document';
import { TranslateService } from '@ngx-translate/core';
import { GungImageUrlService } from 'gung-common';

interface GungGridItem extends GridsterItem {
  productId?: string;
  data: { [s: string]: any };
}

@Injectable({
  providedIn: 'root'
})
export class ExportDragProductService {
  public modalRef: Map<string, NgbModalRef> = new Map<string, NgbModalRef>();

  currentLang = this.translateService.currentLang;
  defaultOrientation = 'LANDSCAPE';

  constructor(
    protected dynamicPdfService: DynamicPdfService,
    protected sanitizer: DomSanitizer,
    protected http: HttpClient,
    protected ngbModal: NgbModal,
    protected translateService: TranslateService,
    protected gungImageUrlService: GungImageUrlService
  ) { }

  selectedPage = 0;
  draggedProduct: string;
  draggedDigitalAsset;

  public renderedItem: { [s: string]: SafeHtml } = {};
  productsGrid: Subject<{ [n: number]: GungGridItem[] }> = new ReplaySubject<{ [n: number]: GungGridItem[] }>(1);

  serviceGrid: { [n: number]: GungGridItem[] } = { 0: [] };

  public selectedTemplate;
  public flow;
  public customer: any;

  addListOfProducts(products, page = this.selectedPage, clearPdfExport: boolean = true) {
    const id = PdfExportDefaultTemplateModalComponent.name;
    const ref = this.ngbModal.open(PdfExportDefaultTemplateModalComponent, {
      size: 'lg'
    });
    ref.componentInstance.delegate = this;
    ref.result.then(
      result => {
        if (result) {
          if (clearPdfExport) {
            this.clearPdfExport();
          }
          this.selectedTemplate = result;
          this.setItems(products);
        }
      },
      reason => undefined
    );
    this.modalRef.set(id, ref);
  }

  setItems(products) {
    let numberOfItems = 0;
    for (const productId of products) {
      const product = {
        modelId: productId.substr(0, productId.indexOf('-')),
        id: productId
      };
      const lastpage = Number(Object.keys(this.serviceGrid)[Object.keys(this.serviceGrid).length - 1]) || 0;
      this.setOneProduct(product, lastpage);
      numberOfItems++;
      if (numberOfItems === this.selectedTemplate.template.maxPerPage) {
        numberOfItems = 0;
        this.addNewPage(null);
      }
    }
  }


  clearPdfExport() {
    this.serviceGrid = {};
    this.productsGrid.next(this.serviceGrid);
  }

  /* Add product to page grid */
  setOneProduct(product, page = this.selectedPage, x = 0, y = 0) {
    if (!this.serviceGrid[page]) {
      this.serviceGrid[page] = [];
    }
    const index = this.serviceGrid[page].findIndex(
      i => i.data.modelId + i.data.productId === product.modelId + product.id
    );
    if (index < 0) {
      const productToAdd = {
        x,
        y,
        cols: this.selectedTemplate.template.cols,
        rows: this.selectedTemplate.template.rows,
        productId: product.id,
        fragment: this.selectedTemplate.template.fragment,
        fragmentFile: this.selectedTemplate.template.fragmentFile,
        data: {
          modelId: product.modelId,
          variantIds: product?.variantIds ? [...product.variantIds] : [product.id],
          flowId: undefined,
          productId: product.id,
          customerId: undefined,
          language: this.currentLang
        }
      };
      if (this.selectedTemplate.template.data.flowId) {
        productToAdd.data.flowId = this.flow.id;
      }
      if (this.selectedTemplate.template.data.customerId) {
        productToAdd.data.customerId = this.customer.id;
      }
      this.serviceGrid[page].push(productToAdd);
      this.productsGrid.next(this.serviceGrid);
      this.getRenderedItemHTML(productToAdd, product.modelId + product.id + '_' + page);
    }
  }

  getRenderedItemHTML(itemToAdd, idWithPage) {
    this.dynamicPdfService
      .getRenderedItemHtml(itemToAdd)
      .pipe(first())
      .subscribe(renderHtml => {
        // We should in general never do what is done below since it opens up for XSS attacks on our applications.
        // However since the HTML we fetch comes from either our git-repo or from documents stored on the customers
        // server it means that we are basically fucked anyways if one of them is compromised.

        /* // Encontrar a parte com o background-image
        let fixRenderHtml = renderHtml + '';
        let start = fixRenderHtml.indexOf('background-image: url(');
        let end = fixRenderHtml.indexOf(');', start);

        if (start !== -1 && end !== -1) {
          // Extrair a URL
          let url = fixRenderHtml.substring(start + 22, end); // 22 = comprimento de "background-image: url("

          // Adicionar as aspas simples
          let newUrl = `'${url}'`;

          // Substituir a URL no texto original
          fixRenderHtml = fixRenderHtml.substring(0, start + 22) + newUrl + fixRenderHtml.substring(end);
        } */
        const unsanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(renderHtml);
        this.renderedItem[idWithPage] = unsanitizedHtml;
      });
  }

  setOneDigitalAsset(imageDigitalAsset, page = this.selectedPage, x = 0, y = 0) {
    if (!this.serviceGrid[page]) {
      this.serviceGrid[page] = [];
    }
    const index = this.serviceGrid[page].findIndex(i => i.data?.url?.includes(imageDigitalAsset.s3Uri));
    if (index < 0) {
      const digitalAssetToAdd = {
        x,
        y,
        cols: 3,
        rows: 5,
        fragment: 'image-cover-wrapper',
        fragmentFile: 'dynamic-product-fragments',
        data: {
          url: this.gungImageUrlService.getUrl(imageDigitalAsset.s3Uri/* ,
            {
              format: 'webp',
              quality: '80'
            } */)
        }
      };
      this.serviceGrid[page].push(digitalAssetToAdd);

      this.productsGrid.next(this.serviceGrid);

      this.getRenderedItemHTML(digitalAssetToAdd, this.gungImageUrlService.getUrl(imageDigitalAsset.s3Uri/* , { format: 'webp', quality: '80' } */));
    }
  }

  setOneNote(note, page = this.selectedPage, x = 0, y = 0) {
    if (!this.serviceGrid[page]) {
      this.serviceGrid[page] = [];
    }

    const noteToAdd = {
      x,
      y,
      cols: 3,
      rows: 3,
      fragment: 'text-display',
      fragmentFile: 'dynamic-product-fragments',
      data: {
        id: 'note_' + +new Date(),
        heading: note.heading,
        note: note.note,
        font: note.font
      }
    };
    this.serviceGrid[page].push(noteToAdd);

    this.productsGrid.next(this.serviceGrid);

    this.getRenderedItemHTML(noteToAdd, noteToAdd.data.id);
  }

  editNote(note, page = this.selectedPage) {
    const index = this.serviceGrid[page].findIndex(n => n.data.id === note.data.id);
    if (index > -1) {
      this.serviceGrid[page][index] = note;
      this.productsGrid.next(this.serviceGrid);
      this.getRenderedItemHTML(note, note.data.id);
    }
  }

  changeTemplate(product, page) {
    const saveHtmlIndex = product.data.modelId + product.data.productId + '_' + page;
    this.dynamicPdfService
      .getRenderedItemHtml(product)
      .pipe(first())
      .subscribe(renderHtml => {
        // We should in general never do what is done below since it opens up for XSS attacks on our applications.
        // However since the HTML we fetch comes from either our git-repo or from documents stored on the customers
        // server it means that we are basically fucked anyways if one of them is compromised.
        const unsanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(renderHtml);
        this.renderedItem[saveHtmlIndex] = unsanitizedHtml;
      });
  }

  getGrids() {
    return this.productsGrid.asObservable();
  }

  changePagePosition(currentPos, newPos) {
    if (!this.serviceGrid[newPos]) {
      this.serviceGrid[newPos] = [];
    }
    const copyCurrent = JSON.parse(JSON.stringify(this.serviceGrid[currentPos]));
    const copyNew = JSON.parse(JSON.stringify(this.serviceGrid[newPos]));

    // Update all renderedItem keys / indexes to correspond to the new page numbers
    let changedRenderItems = {};
    for (const key in this.renderedItem) {
      if (Object.prototype.hasOwnProperty.call(this.renderedItem, key)) {
        const element = this.renderedItem[key];
        const idParts = key.split("_")
        const renderPage = Number(idParts[idParts.length - 1]);
        if (renderPage === currentPos) {
          const productId = idParts.slice(0, -1).join("_");
          changedRenderItems[productId + '_' + newPos] = element
          delete this.renderedItem[key];
        } else if (renderPage === newPos) {
          const productId = idParts.slice(0, -1).join("_");
          changedRenderItems[productId + '_' + currentPos] = element
          delete this.renderedItem[key];
        }
      }
    }
    if (Object.keys(changedRenderItems).length !== 0) {
      for (const key in changedRenderItems) {
        if (Object.prototype.hasOwnProperty.call(changedRenderItems, key)) {
          const element = changedRenderItems[key];
          this.renderedItem[key] = element;
        }
      }
    }

    this.serviceGrid[currentPos] = copyNew;
    this.serviceGrid[newPos] = copyCurrent;
    this.productsGrid.next(this.serviceGrid);
  }

  removeItem(item, page) {
    let index;
    if (item.data.url) {
      index = this.serviceGrid[page].findIndex(i => i.data.url === item.data.url);
    } else if (item.data.id) {
      index = this.serviceGrid[page].findIndex(i => i.data.id === item.data.id);
    } else {
      index = this.serviceGrid[page].findIndex(i => i.productId === item.productId);
    }

    if (index > -1) {
      this.serviceGrid[page].splice(index, 1);
    }
    this.productsGrid.next(this.serviceGrid);
  }

  removePage(page) {
    const lastPage = Number(Object.keys(this.serviceGrid)[Object.keys(this.serviceGrid).length - 1]);

    // Re-index renderedItem keys for pages above the removed one
    const changedRenderItems: { [key: string]: any } = {};
    for (const key in this.renderedItem) {
      if (Object.prototype.hasOwnProperty.call(this.renderedItem, key)) {
        const idParts = key.split('_');
        const renderPage = Number(idParts[idParts.length - 1]);
        if (renderPage === page) {
          delete this.renderedItem[key];
        } else if (renderPage > page) {
          const productId = idParts.slice(0, -1).join('_');
          changedRenderItems[productId + '_' + (renderPage - 1)] = this.renderedItem[key];
          delete this.renderedItem[key];
        }
      }
    }
    for (const key in changedRenderItems) {
      if (Object.prototype.hasOwnProperty.call(changedRenderItems, key)) {
        this.renderedItem[key] = changedRenderItems[key];
      }
    }

    // Shift all pages above the removed one down by 1
    for (let index = page; index < lastPage; index++) {
      this.serviceGrid[index] = this.serviceGrid[index + 1];
    }
    delete this.serviceGrid[lastPage];

    this.productsGrid.next(this.serviceGrid);
  }

  addNewPage(position) {
    const lastpage = Number(Object.keys(this.serviceGrid)[Object.keys(this.serviceGrid).length - 1]);
    if (!position) {
      this.serviceGrid[lastpage + 1] = [];
    } else {
      // Update all renderedItem keys / indexes to correspond to the new page numbers
      let changedRenderItems = {};
      for (const key in this.renderedItem) {
        if (Object.prototype.hasOwnProperty.call(this.renderedItem, key)) {
          const element = this.renderedItem[key];
          const idParts = key.split("_")
          const renderPage = Number(idParts[idParts.length - 1]);
          if (renderPage >= position) {
            const productId = idParts.slice(0, -1).join("_");
            changedRenderItems[productId + '_' + (renderPage + 1)] = element
            delete this.renderedItem[key];
          }

        }
      }
      if (Object.keys(changedRenderItems).length !== 0) {
        for (const key in changedRenderItems) {
          if (Object.prototype.hasOwnProperty.call(changedRenderItems, key)) {
            const element = changedRenderItems[key];
            this.renderedItem[key] = element;
          }
        }
      }

      // Update update all page numbers for the service grid
      for (let index = lastpage; index >= position; index--) {
        this.serviceGrid[index + 1] = this.serviceGrid[index]
      }
      // Ensure that the new page is blank
      this.serviceGrid[position] = [];
    }
    this.productsGrid.next(this.serviceGrid);
  }

  fillPages(pdfExport: PdfDocument) {
    this.serviceGrid = {};
    let i = 0;
    for (const itemsPage of pdfExport.pages) {
      this.serviceGrid[i] = itemsPage.items;
      for (const item of itemsPage.items) {
        if (item.fragment === 'text-display') {
          this.getRenderedItemHTML(item, item.data.id);
        } else if (!item.data?.url) {
          this.getRenderedItemHTML(item, item.data.modelId + item.data.productId + '_' + i);
        } else {
          this.getRenderedItemHTML(item, item.data.url);
        }
      }
      i++;
    }
    this.productsGrid.next(this.serviceGrid);
  }
}
